/**
 * What a three shadow needs to draw into its own rectangle of an atlas that other shadows share:
 * three r186's own `LightShadow` members, and a scissor on the shared target.
 */
/**
 * Confines the shadow's draws to `rect`, given in units of `mapSize` as three gives a viewport
 * (`WebGLShadowMap.js:345-350`). three binds a target with its own scissor
 * (`WebGLRenderer.js:3040-3043`), and shrinks `mapSize` on a GPU whose textures are smaller than the
 * atlas (`WebGLShadowMap.js:180-198`), so the scissor scales with it. A shadow without a map has none.
 */
export function confineShadowScissor(shadow, rect) {
    if (!shadow.map)
        return;
    const { x, y } = shadow.mapSize;
    shadow.map.scissor.set(rect.x * x, rect.y * y, rect.z * x, rect.w * y);
    shadow.map.scissorTest = true;
}
//# sourceMappingURL=sharedAtlasShadow.js.map